<template>
  <v-card
    class="io-folder"
    outlined
    :ripple="false"
    @click.stop="$router.push(`/filter/${filter.filter_id}`)"
    style="padding: 3px;"
  >
    <v-card-title
      class="io-folder-text"
      style="display: flex; padding: 5px;"
    >
      <v-icon class="mr-2">mdi-filter-outline</v-icon>
      <span style="overflow-x: hidden; font-size: 15px;">{{title}}</span>
      <v-spacer></v-spacer>
      <input v-show="selecting" v-model="itemSelected" type="checkbox" class="ml-3 mr-4" @click.stop="$emit('toggleSelection', filter)" />
      <v-menu
        offset-y
        class="mt-2"
        dense
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-show="!selecting"
            v-bind="attrs"
            v-on="on"
            fab
            x-small
            text
          >
            <v-icon size="20">
              mdi-dots-vertical
            </v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item
            @click="renaming = true; newName = filter.title;"
          >
            <v-list-item-icon>
              <v-icon>mdi-pencil</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{$t('rename')}}</v-list-item-title>
          </v-list-item>
          <add-to-folder-list-item
            v-if="!unableToAddToFolder"
            id_type="filter_id"
            type="filter"
            :folder_name="filter.title || 'Filter'"
            :id="filter.filter_id"
          />
          <v-divider></v-divider>
          <v-list-item
            @click="deleting = true"
            link
          >
            <v-list-item-icon>
              <v-icon>mdi-delete</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{$t('delete')}}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-card-title>
    <v-dialog max-width="600" v-model="renaming">
      <v-card
        max-width="600"
        class="pt-10"
      >
        <v-card-text>
          <v-text-field
            v-model="newName"
            solo
            autofocus
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="renaming = false; newName = ''">{{$t('cancel')}}</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="rename()"
            :disabled="!newName || newName == filter.title"
          > {{$t('rename')}} </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirmation-dialog
      :show="deleting"
      :text="$t('filter.delete_filter')"
      :subText="$t('filter.sure_delete', [filter.title])"
      @decline="deleting = false"
      @accept="confirmDeleteFilter()"
      btnColor="red"
      :btnText="$t('delete')"
    ></confirmation-dialog>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ConfirmationDialog from '../ConfirmationDialog.vue'
import AddToFolderListItem from '@/components/folder/AddToFolderListItem.vue'

export default {
  props: ['filter', 'selecting', 'unableToAddToFolder'],
  components: {
    ConfirmationDialog,
    AddToFolderListItem
  },
  data: () => ({
    renaming: false,
    newName: '',
    deleting: false,
    choosingFolder: false,
    folder: null
  }),
  methods: {
    rename() {
      if (!this.newName) return
      this.updateTitle({
        ...this.filter,
        title: this.newName
      })
        .then(() => {
          this.success(this.$t('filter.filter_renamed'))
          this.renaming = false
        })
        .catch(e => this.error(e))
    },
    addToFolder(folder) {
      this.addFolder({
        parent: folder.filter_id,
        name: this.filter.title || 'Ei otsikkoa',
        type: 'filter',
        filter_id: this.filter.filter_id
      })
        .then(() => {
          this.success("Suodatus lisätty kansioon!")
          this.choosingFolder = false
          this.folder = null
        })
        .catch(e => this.error(e))
    },
    confirmDeleteFilter() {
      this.deleteFilter(this.filter.filter_id)
        .then(() => {
          this.info(this.$t('filter.filter_deleted'))
          this.deleting = false
        })
        .catch(e => this.error(e))
    },
    ...mapActions('filter', [
      'updateTitle',
      'deleteFilter'
    ]),
    ...mapActions('folder', [
      'addFolder'
    ]),
    ...mapActions('noti', [
      'error',
      'success',
      'info'
    ])
  },
  computed: {
    ...mapGetters('batch', [
      'selectedItems'
    ]),
    title() {
      // If longer than 20 characters, cut off and add ellipsis
      const lim = 20
      if (this.filter.title.length > lim) {
        return this.filter.title.substring(0, lim) + '...'
      }

      return this.filter.title
    },
    itemSelected: {
      get() {
        return this.selectedItems.some(selectedItem => selectedItem.id === this.filter.filter_id)
      },
      set() {
        // Do nothing - we only use to check the value in a v-model directive
      }
    },
  }
}
</script>

<style scoped>
input[type='checkbox'] {
  transform: scale(1.4, 1.4);
}
.raw-json-menu {
  max-width: 400px;
}
pre {
  white-space: pre-wrap;
  word-wrap: break-word;
}
</style>
